"use client";

import { c as _c } from "react/compiler-runtime";
import type { SearchEntityResult } from "fansunited-data-layer";
import type { FUSportsEventDetails } from "../data/types";
import { ScoreBreakdown } from "../partials/ScoreBreakdown";
import { MainEventsTimeline } from "../partials/MainEventsTimeline";
import type { SportEventSport } from "../utils/sportShape";
interface Props {
  details: FUSportsEventDetails;
  entities: Record<string, SearchEntityResult>;
  sport: SportEventSport;
  periodLabelPrefix: string;
  periodHeaderLabel: string;
}
export function OverviewTab(t0) {
  const $ = _c(12);
  const {
    details,
    entities,
    sport,
    periodLabelPrefix,
    periodHeaderLabel
  } = t0;
  let t1;
  if ($[0] !== details || $[1] !== entities || $[2] !== periodHeaderLabel || $[3] !== periodLabelPrefix || $[4] !== sport) {
    t1 = <ScoreBreakdown details={details} entities={entities} sport={sport} periodLabelPrefix={periodLabelPrefix} periodHeaderLabel={periodHeaderLabel} />;
    $[0] = details;
    $[1] = entities;
    $[2] = periodHeaderLabel;
    $[3] = periodLabelPrefix;
    $[4] = sport;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== details || $[7] !== entities) {
    t2 = <MainEventsTimeline details={details} entities={entities} />;
    $[6] = details;
    $[7] = entities;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <div className="space-y-6">{t1}{t2}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}